import React, { useEffect, useState, useCallback,useRef } from 'react';
import axios from 'axios';
import MobileFilter from '../../common/Filter/MobileFilter';
import { Link, useHistory } from 'react-router-dom';
import filterStyle from '../../common/Filter/mobile-filter.scss';
import styles from './listing.scss';
import { connect, useDispatch, useSelector } from 'react-redux';
import { getListingData, resetSearchData, setTabStatus, updateDeletionPending, toggleSearchSlider,toggleActionCardSlider,actionCardFilter , updateGenericDeletionPending, setPreviousTabIndex, filterQuery, setPendingTabs, reloadActionCardSlider, clickTrack,fetchPsvInfo } from '../../actions/products';
import { showToastMessage } from '../../actions/toastmessage';
import withRipple from 'jd-library/withRipple';
import AnimateOnHover from 'jd-library/AnimateOnHover';
import Tabs from 'jd-library/Tabs';
import MorePopover from 'jd-library/MorePopover'
import MobileFilterRipple from '../../common/Filter/MobileFilterRipple';
import Loader from '../../common/Loader/Loader';
import SliderHeader from 'jd-library/SliderHeader';
import {checkLoggedIn,filterDataAry,identifyAuditFlow,backToApp,updtLbl} from '../../utills';
import Search from '../search-product/SearchProduct';
import SliderWrapper from 'jd-library/SliderWrapper';
import BulkUploadSlider from '../bulk-upload/BulkUploadSlider'
// import BulkUploadSliderDC from "./bulk-upload/BulkUploadSlider"
import BulkUploadNewSlider from "./bulk-upload/BulkUploadNewSlider"
import ExportHistorySlider from './bulk-upload/ExportHistorySlider';
import HorizontalPhotoList from '../photo-slider/HorizontalPhotoList';
import ToggleLeftMenu from '../../common/ToggleLeftMenu';
import { pageLoad, pageLoadForIos, callBackForApps } from '../../common/Utills';
import config from '../../../config/config'
import NotificationSlider from './Notifications/NotificationSlider';
import Notifications from './Notifications';
import { setSlider } from './Notifications/redux/action';
import CardSlider from '../../common/Listing/CardSlider';
import ActionCardClickSlider from '../../common/Listing/ActionCard-click-slider';
import { openInIframe } from '../../common/Listing/utils';


const contractorTypes = ["CONTRACTOR", "CONTRACTORV2","CONTRACTORV3"];

const ListingHeader = props => {
	let { filterObj = {} } = props.listing;
	filterObj = props.filterProductObj ? props.filterProductObj : filterObj;
	let products = props.listing.results;
	const isProductOnlyProfile = Number(props.session?.newProfile);
	const profileObject = props.session?.profileObject

	

	let isVendor = false;
	const [filterOpen, setFilterOpen] = useState(false);
	const [bulkUploadOpen,updateBulkUploadOpen] = useState(false);
	const [bulkUpdateOpen,updateBulkUpdateOpen] = useState(false);
	const [exportHistoryToggle, setExportHistoryToggle] = useState(() => false);
	const [clearFilter,setClearFilter] = useState(false);
	const [viaOmni, setViaOmni] = useState(props?.session?.viaOmni || false);
	const isLogin = props.session.user.loggedUser;
	const isJdRep = props.session.user.loggedUser && props.session.user.loggedUser.userType == "JDEMPLOYEE";
	const isOwner = props.session.user.loggedUser && props.session.user.loggedUser.userType == "OWNER";
	let history = useHistory();
	const [isScrolled, setScroll] = useState(
		typeof document === 'object' && (document.scrollingElement.scrollTop > 0)
	);
	const [auditMultiSelect , toggleAuditMultiSelect] = useState(false);
    const isNotificationSlider = useSelector(state => state?.notifications?.slider)
    const getNotificationData = useSelector(state => state?.notifications?.counts)
	const reduxPendingTabs = useSelector(state => state.products.pendingTabs)
	const [actionCardSliderName, setActionCardSliderName] = useState('')
	const isReloadCardSlider =  useSelector(state=>state.products.isReloadCardSlider)
	const [actionCardSliderFilter, setActionCardSliderFilter] = useState('')
	const cardCounts = props.cardCounts;
	const [hidePhotoList,setHidePhotoList] =  useState(true);
	
	useEffect(() => {
		if (Object.values(cardCounts).length!==0) {
			let checkCards = ["addPriceMissingCount", "descMissingCount", ,"priceMissingCount", "rejectedCount", "specMissingCount"];
			if (isLogin && !isOwner) {
				checkCards.push("scoreLessThanHundred");
			} else if (isOwner) {
				checkCards = [...checkCards, "imgMissingCount","smartPriceMissingCount", "nonexistingjdmartidcount"];
			}
			const countExist = checkCards.find(item=>cardCounts[item] > 0)
			if(!countExist || getNotificationData?.totalActive <= 0){
				setHidePhotoList(false);
			}else {
				setHidePhotoList(true);
			}	
		}
	},[cardCounts,props.vendorImages])

	useEffect(() => {
	   props.fetchPsvInfo();
	}, [])	
	
	const actionCardData =  useSelector(state=> state?.products?.actionCardFilter)
	const tabRef = useRef(null);
	const dispatch = useDispatch();

	const getSelectedFilter = (key, value) => {
		let flag =
			filterObj[key] && filterObj[key].indexOf(value) != -1 ? true : false;
		return flag;
	};
	const onAuditFilterChange = (data,index) =>{
		if(index){
			toggleAuditMultiSelect(true);
		}else{
			toggleAuditMultiSelect(false);
		}
	}
let filterData = filterDataAry("",getSelectedFilter,props.session.viaOmni)
	if(!profileObject.isRE && !profileObject.isSO && profileObject.isSer && !props.session.viaOmni){
		filterData.splice(0,2);
	}

	const [filter, setFilters] = React.useState(filterData);
	let listingFilterRef = useRef(null);

	let leftIconArr = [];
	let rightIconArr = [];

	let searchByDocId = false;
	const docIdCheck = identifyAuditFlow({query: true});
	if(docIdCheck.searchBy == 'docId'){
		searchByDocId = true;
	}
	useEffect(()=>{
		if(clearFilter){
			setTimeout(() => {
				setClearFilter(false)
			}, 300);
		}
	},[clearFilter])

	// useEffect(() => {
	// 	if (isReloadCardSlider) {
	// 		props.getListingData({
	// 			isFilter: true,
	// 			filterStr: actionCardSliderFilter || actionCardData?.filterQuery,
	// 			cb: (data) => {
	// 			}
	// 		})
    //     	dispatch(reloadActionCardSlider({isReloadCardSlider:false}))
	// 	}
	// }, [isReloadCardSlider])	

	const isCorrector =  props.session.user.loggedUser?.subType == 'CORRECTOR';
	let auditorObjection = props.isAuditor && props.tabKey == 'objectionable';
	if(props.isAuditor){
		leftIconArr = props.deviceData.isMobile ? [
			{
				className: 'icon-hdrBackNew',
				ariaLabel: 'Go back',
				onClick: () => {
						const search = identifyAuditFlow({query: true});
						if(search.fromFetchFlow) {
							history.push("/audit-home");
						} else {
							history.replace("/audit-home");
						}
				}
			}
		] :
		[
			{
				isText: true,
				label: 'Clear',
				className: styles['header-smallText'],
				onClick: () => {
					setClearFilter(true)
					props.updateDeletionPending({deletionPendingList: []});
				}
			}
		] ;
		if(props.showSearchAdd){
			rightIconArr = [];
				if (isCorrector) {
					rightIconArr.push({
						className: '',
						holderClass: '',
						onClick: () => {}
					});
				}
			if(!filterOpen) {
				rightIconArr.push({
					className: 'icon-filterNew-holder',
					isText:true,
				label:(<><i className={`${'icon-filterNew'}`}></i>{Object.keys(filterObj).length > 0 && <span className={styles['header-red-dot']}/>}</>),
					onClick: () => {
						if(auditorObjection){
							return;
						}
						openFilter();
					}
				});
				rightIconArr.push({
					className: 'icon-HDRsearch',
					ariaLabel: 'Search',
					holderClass: 'auditor-search',
					onClick: () => {
						if(auditorObjection){
							return;
						}
						redirectToSearch();
					}
				});
				if (!isCorrector) {
					rightIconArr.push({
						parentClass: 'auditor-more-menu',
						menuClass:'auditor-more-menu-option',
						isMoreMenu: true,
						options : [{
							label: "Remove Doc ID from Audit Queue",
							onClick : () => {
								props.toggleAuditQueueSlider && props.toggleAuditQueueSlider(true);
							}
						}]
					});
				} 
			} else {
				rightIconArr = props.deviceData.isMobile ? [
					{
						isText: true,
						label: 'Clear',
						className: styles['header-smallText'],
						onClick: () => {
							setClearFilter(true)
							props.updateDeletionPending({deletionPendingList: []});
						}
					}
				] :
				[
					{
						className: 'icon-HDRcross',
						ariaLabel: 'Close filter',
						onClick: () => {
							closeFilter();
							if(props.session.source == "webstore") {
								window.history.back();
							}
						}
					}
				];
			}
			filterData = filterDataAry("audit-showSearchAdd",getSelectedFilter,props.session.viaOmni)
		}
	}else{
		if(props.tabKey == 'brand'){
			filterData = filterDataAry("tabkey-brand",getSelectedFilter,props.session.viaOmni)
		}
		leftIconArr = props.deviceData.isMobile ? [
			{
				className: 'icon-HDRback',
				ariaLabel: 'Go back',
				onClick: () => {
					closeFilter();
					if(props.session.source == "webstore") {
						window.history.back();
					}
				}
			}
		] : [
			{
				isText: true,
				label: 'Clear',
				className: styles['header-smallText'],
				onClick: () => {
					setClearFilter(true)
					props.updateDeletionPending({deletionPendingList: []});
					props.updateGenericDeletionPending({genericDeletionList: []});
				}
			}
		];
		rightIconArr = props.deviceData.isMobile ? [
			{
				isText: true,
				label: 'Clear',
				className: styles['header-smallText'],
				onClick: () => {
					setClearFilter(true)
					props.updateDeletionPending({deletionPendingList: []});
					props.updateGenericDeletionPending({genericDeletionList: []});
				}
			}
		] : [
			{
				className: 'icon-HDRcross',
				ariaLabel: 'Close filter',
				onClick: () => {
					closeFilter();
					if(props.session.source == "webstore") {
						window.history.back();
					}
				}
			}
		];
	}

	const onFilterSubmit = filters => {
		if(props.session.source == 'webstore'){
			props
			.getVendorProducts({
				filterObj: filters
			})
			.then(() => {
				window.history.back();
				closeFilter();
			});
		}else{
			filterChangeHandle(filters);
			window.history.back();
			// props
			// .getListingData({
			// 	filterObj: filters
			// })
			// .then(() => {
				closeFilter();
			// });
		}
	};

	const cardClickHandler = (val) => {
		props.showHideLoader({ showLoader: true });
		setActionCardSliderFilter(val.filter)
		props.actionCardFilter({cardName: val.name,filterQuery: val.filter,type:val.type})
		props.getListingData({
			isFilter: true,
			filterStr: val.filter,
			cardName: val.name,
			count: val.count,
			cb: (data) => {
				props.showHideLoader({ showLoader: false });
				props.toggleActionCardSlider({isActionCardSliderOpen: true}) 
				if(props.deviceData.isMobile){
					let url =  `/smartcard/${val.type}`;
					history.push(url);
				}
			}
		})
	}

	const filterInitRef = useRef(false);
	const openFilter = () => {
		props.showHideLoader({ showLoader: true });
		if(!props.session.viaOmni)
			props.clickTrack({li: 'dc_filter',ll: 'digital_catalog', userBasedCheck: true})
		window.history.pushState({ filter: 'filter' }, 'filters');
		window.addEventListener('popstate', closeFilter);
		setFilterOpen(true);
		if(props.deviceData.isIphone){
			document.body.scrollTo(0,0);
		}
		if((props.session.source == 'webstore' || props.session.viaOmni) && !filterInitRef.current){
			fetchFilterAndOpen();
		}else if(props.session.source == 'webstore' || props.session.viaOmni){
			resetAndOpenFilter();
		}else{
			resetAndOpenFilter();
			if(!(!profileObject.isRE && !profileObject.isSO && profileObject.isSer)){
				fetchFilterAndOpen();
			}
			setFilters(filterData);
			setTimeout(() => {
				props.showHideLoader({ showLoader: false });
			}, 0);
		}
	};

	const resetAndOpenFilter = () => {
		let newFilterData = [];
		let filterList = filter && filter.length && filter[0].serviceKey === 'brands' && filter[0]?.subMenu && filter[0].subMenu.length ? [...filter] : listingFilterRef.current;
		for(let i = 0; i < filterList?.length; i++){
			let eachFilter = filterList[i];
			if(eachFilter?.subMenu){
				eachFilter.subMenu.map((cur) => {
					cur.isChecked = getSelectedFilter(filterList[i].serviceKey, cur.value);
				})
			}
			newFilterData.push(eachFilter);
		}
		if(props.tabKey === 'omniService' && viaOmni && newFilterData[0].serviceKey === 'brands') {
			newFilterData.shift();
		} 
		setFilters(newFilterData);
		setTimeout(() => {
			props.showHideLoader({ showLoader: false });
		}, 0);
	}

	const getFilterTemplate = () => {
		let eachFilter = {
			type: 'checkbox',
			variant: 'circle',
			subMenu: [],
			hasSearch: true,
			labelPosition: 'after'
		}
		return eachFilter;
	}

	const checkFilterAndOpen = (filterData) => {
		setFilters(filterData);
	}

	const filterLableStyle={
		width: '100%',
		display: 'flex',
		justifyContent: 'space-between'
	}

	const fetchFilterAndOpen = () => {
		props.showHideLoader({ showLoader: true });
		let filterData = [];
		// let categoryFilterPromise = axios.get('/marketplace/products/services/getProductTypesForFilter.service?status=ACTIVE');
		let barndFilterPromise = axios.get('/marketplace/static/php/web/b2bWebsite.php?action=listAllBrands&token='+props.session.token);

		Promise.all([barndFilterPromise])
		.then(values => {
			// let categoryFilter = getFilterTemplate();
			// categoryFilter.label = 'Category';
			// categoryFilter.placeholder = 'Search Category';
			// categoryFilter.serviceKey = 'listOfPuvIds';

			// for (let i = 0; i < values[0].data.productTypes.length; i++) {
			// 	let details = {};
			// 	details.label = <div style={filterLableStyle}><span>{values[0].data.productTypes[i][1]}</span><span>{values[0].data.productTypes[i][2]}</span></div>
			// 	details.rawLabel = values[0].data.productTypes[i][1];
			// 	details.value = values[0].data.productTypes[i][0];
			// 	details.count = values[0].data.productTypes[i][2];
			// 	details.isChecked = getSelectedFilter('listOfPuvIds', values[0].data.productTypes[i][0])
			// 	categoryFilter.subMenu.push(details);
			// }
			// filterData.push(categoryFilter);

			let brandFilter = getFilterTemplate();
				brandFilter.label = 'Brand';
				brandFilter.placeholder = 'Search Brand';
				brandFilter.serviceKey = 'brands';

			for (let i = 0; i < values[0].data.data.length; i++) {
				let details = {};
				details.label = <div style={filterLableStyle}><span>{values[0].data.data[i]}</span></div>
				details.rawLabel = values[0].data.data[i];
				details.value = values[0].data.data[i];
				// details.count = values[0].data.data[i];
				details.isChecked = getSelectedFilter('brands', values[0].data.data[i])
				brandFilter.subMenu.push(details);
			}
			filterData = filter && filter.length && filter[0].serviceKey === 'brands' ? [...filter] : listingFilterRef.current;
			filterData[0] = brandFilter
			listingFilterRef.current = [...filterData];
			if(props.tabKey === 'omniService' && viaOmni && filterData[0].serviceKey === 'brands') {
				filterData.shift();
			}
			filterInitRef.current = true;
			props.showHideLoader({ showLoader: false });
			setFilters(filterData)
			checkFilterAndOpen(filterData)
		})
	}

	const closeFilter = () => {
		setFilterOpen(false);
		window.removeEventListener('popstate', closeFilter);
	};

	const handleScroll = useCallback((e) => {
		let isScrolled = document.scrollingElement.scrollTop > 0 ? true : false;
		setScroll(isScrolled);
	}, []);
	useEffect(() => {
		window.addEventListener('scroll', handleScroll);
		if(window){
            window.appHandler = (jsonStr) => {
                try {
                console.log('callback',jsonStr);
                const transformedJson = JSON.parse(jsonStr);
                const {eventType, redirectionurl} = transformedJson;
                if(redirectionurl){
                    window.location.replace(redirectionurl);
                }else if(eventType == "deviceback"){
                    if (JdLiteInterface && JdLiteInterface.verticalHandler) {
                        const exitJson ={"action":"exit"};
                        JdLiteInterface.verticalHandler(JSON.stringify(exitJson));
                    }
                }
                } catch (e) {
                console.log(e)
                }
            };
			if(props.isJdSourceAndroid){
                pageLoad();
            }else if (props.isJdBusinessIOS) {
				pageLoadForIos();
			}
        }
		return () => {
			window.removeEventListener('popstate', closeFilter);
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);
	const [bulkStatus, updateBulkStatus] = useState(false);
	useEffect(() => {
		if (bulkStatus && !bulkUploadOpen) {
			props.getListingData({})
		}
	}, [bulkUploadOpen])

	useEffect(() => {
		if(!filterInitRef.current)
			setFilters(filterData);
	},[props.listing.filterObj])

	const redirectToSearch = () => {
		if(!props.isAuditor){
			// props.setTabStatus({tabKey: undefined});
			props.updateDeletionPending({deletionPendingList: []});
			props.updateGenericDeletionPending({genericDeletionList: []});
		}
		props.resetSearchData().then(res => {
			if(!props.deviceData.isMobile){
				props.toggleSearchSlider({isSearchSliderOpen: true});
				return;
			}
			let url =  "/search";
			if(props.isAuditor) {
				url += window.location.search;
			}
			if(props.tabKey == "brand") {
				/* Redirecting to search and adding viaSuggested=true to the history object if the tabkey is brand. */
				url += "?viaSuggested=true";
			}
			history.push(url);
		});
	};
	const redirectToBulkUpload = () => {
		checkLoggedIn({
			cb: () => {
				if(props.isMobile) {
					history.push("/bulk-upload");
				} else {
					updateBulkUploadOpen(true);
				}
				//window.history.pushState({bulkUploadOpen: 'open'}, '');
				//history.push('/bulk-upload');
			},
			history
		})
	}
	const showCompanyDetails = props.session.showCompanyDetails;

	let isContractor = props.session.user.loggedUser && (contractorTypes.indexOf(props.session.user.loggedUser.subType) != -1) ;
	const isContractorV1 = (props.session?.user?.loggedUser?.subType == 'CONTRACTOR');
	const isContractorV2 = (props.session?.user?.loggedUser?.subType == 'CONTRACTORV2');
	const isContractorV3 = (props.session?.user?.loggedUser?.subType == 'CONTRACTORV3');
	const isObeFromSSO = props.session.user?.loggedUser?.subType == "OBE";
    const cSearchData = sessionStorage.getItem("contractSearch")

	//Approval and deletion pending logic
	const objectionableCount = Number(props.listing.objectionableTotalCount);
	const showPendingTabs = true // (props.tabKey == 'productConflict' || props.tabKey == 'approvalPending' || props.tabKey == 'deletionPending' || props.tabKey == 'objectionable' || props.tabKey == 'brand') || (props.session.source == 'b2b' && (props.listing.approvalPendingCount || props.listing.productConflictCount || props.listing.deletionPendingCount || objectionableCount || props.listing.suggestedProductsCount || props.listing.auditPendingCount || props.listing.documentPendingCount));
	const showAuditorPendingTabs = ((props.tabKey == 'objectionable' || props.listing.objectionableTotalCount) && searchByDocId);
	const [activeTab, setActiveTab] = React.useState(props.activeTab);
	useEffect(() => {
		if(!viaOmni) {
			setActiveTab(props.activeTab);
			tabRef?.current?.children[0]?.children?.length && tabRef?.current?.children[0]?.children[props.activeTab].scrollIntoView({behaviour:'smooth',block:'center',inline:'start'})
		}
		if(viaOmni) {
			setActiveTab(props.activeTab);
		}
	}, [props.activeTab])
	useEffect(()=>{
		setActiveTab(props.tabIndex);
		tabRef?.current?.children[0]?.children?.length && tabRef?.current?.children[0]?.children[props.tabIndex].scrollIntoView({behaviour:'smooth',block:'center',inline:'start'})
	},[props.tabIndex])

	const getTabLabel = (label, count, blackCss = '') => {
		let finalCount = count;
		return(
			<div className={styles['tab-label']}>
				<div className={styles['label']}>{label}</div>
				{finalCount != "0" ? <div aria-label={`${finalCount} items`} className={`${styles['count']} ${ blackCss ? styles['count-black'] : styles['count-red']}`}>{finalCount}</div> : null}
			</div>
		)
	}
	
	let allTabLbl = (props.listing?.totalActiveLbl ? props.listing?.totalActiveLbl : viaOmni ? 'Product / Service' : profileObject?.SingleLabelWithSpace);	
	allTabLbl = allTabLbl.includes(' / ') ? 'All ' + allTabLbl.replace('Service', '\nService') : 'All \n' + allTabLbl;
	allTabLbl = allTabLbl.replace('Product', 'Products').replace('Service', 'Services');
	
	const pendingTabs = {
		tabs: [{
			value: viaOmni ? allTabLbl : getTabLabel(allTabLbl, '0'), tabKey: undefined, width: !props.deviceData.isMobile ? '15' : '40'
		}],
		onTabChange: (index,e) => {
			props.onTabChange && props.onTabChange(index, activeTab, pendingTabs.tabs[index]['tabKey']);
			setActiveTab(index);
			dispatch(filterQuery(''));
			dispatch(setPreviousTabIndex({tabIndex:index}));
			e && e.currentTarget.scrollIntoView({behaviour:'smooth',block:'center',inline:'center'});
			setTimeout(()=>{
				window.scrollTo(0,0);
			},500)
		}
	}
	const pendingAuditorTabs = {
		tabs: [{
			value: `Normal ${profileObject?.PluralLabelWithSpace}`, tabKey: undefined, width: !props.deviceData.isMobile ? '15' : null
		}],
		onTabChange: (index) => {
			props.onTabChange && props.onTabChange(index, activeTab, pendingAuditorTabs.tabs[index]['tabKey'],props.filterProductObj);
			setActiveTab(index);
			window.scrollTo(0,0);
		}
	}
	const filterChangeHandle = (filter) => {
		if(!props.session.viaOmni && props.tabKey !== "omniService") {
			setActiveTab(0);
		}
		props.filterCloseCB && props.filterCloseCB(filter);
	}

	useEffect(() => {
		const objectionableCount = Number(props.listing.objectionableTotalCount);
		if(props.tabKey == 'objectionable' && activeTab != 0 && objectionableCount == 0) {
			props.onTabChange && props.onTabChange(0, activeTab, pendingTabs.tabs[0]['tabKey']);
			setActiveTab(0);
		}
	}, [props.listing, props.tabKey, activeTab]);

	useEffect(() => {
		if (window.location?.pathname.includes("/brochure")) {
			const ind = pendingTabs.tabs.findIndex(item => item.tabKey == "brochure")
			setActiveTab(ind)
			props.setTabStatus({ tabKey: "brochure" })
			history.replace({ pathname: '/products', state: { skipDataLoad: true } });
		}
	}, [pendingTabs])

	if (!props.isAuditor && !viaOmni) {
		pendingTabs.tabs.push({value:  getTabLabel(props.session.brochureButton ? props.session.brochureButton : 'Brochure', props.listing?.totalBrochureCount || '0', '1'), tabKey: 'brochure', width: !props.deviceData.isMobile ? '15' : props.session.brochureButton === 'Rate Card / Brochure' ? 40 : null})	
	}	
	if(!props.session.isReadOnly && props.listing.productConflictCount && props.listing.productConflictCount != "0" || props.tabKey == 'productConflict'){
		pendingTabs.tabs.push({value: getTabLabel( `${profileObject.SingleLabelWithSpace} Conflict`, props.listing.productConflictCount), tabKey: 'productConflict', width: !props.deviceData.isMobile ? '15' : null})
	}
	if((props.listing.suggestedProductsCount && !viaOmni && props.listing.suggestedProductsCount != 0 || props.tabKey == 'brand') && !isJdRep && !isContractor && !isObeFromSSO ){
		pendingTabs.tabs.push({value:  getTabLabel(`Suggested ${profileObject.PluralLabelWithSpace}`, '0'), tabKey: 'brand', width: !props.deviceData.isMobile ? '15' : '42'})
	}
	if((props.listing.approvalPendingCount && props.listing.approvalPendingCount != "0" || props.tabKey == 'approvalPending') && !viaOmni){
		pendingTabs.tabs.push({value: getTabLabel('Approval \nPending', props.listing.approvalPendingCount), tabKey: 'approvalPending', width: !props.deviceData.isMobile ? '15' : '50'})
	}
	if((props.listing.deletionPendingCount && props.listing.deletionPendingCount != "0" || props.tabKey == 'deletionPending')){
		pendingTabs.tabs.push({value: getTabLabel('Deletion \nPending', props.listing.deletionPendingCount), tabKey: 'deletionPending', width: !props.deviceData.isMobile ? '15' : null})
	}
	if((props.listing.inventoryComplianceCount && props.listing.inventoryComplianceCount != 0 || props.tabKey == 'inventoryCompliance') && !isContractor && !isObeFromSSO){
		pendingTabs.tabs.push({value:  getTabLabel('Inventory \nCompliance', props.listing.inventoryComplianceCount), tabKey: 'inventoryCompliance', width: !props.deviceData.isMobile ? '15' : null})
	}
	if(props.listing.rejectedCount && props.listing.rejectedCount != "0" && !viaOmni || props.tabKey == 'rejected'){
		pendingTabs.tabs.push({value: getTabLabel(`Rejected ${updtLbl(props.listing.rejectedCount, props.listing.rejectedCountLbl)}`, props.listing.rejectedCount), tabKey: 'rejected', width: !props.deviceData.isMobile ? '15' : '50'})
	}
	
	if((props.listing.documentPendingCount && props.listing.documentPendingCount != "0" || props.tabKey == 'documentPending') /* && !props.session.isJdMart */ && !viaOmni){
		pendingTabs.tabs.push({value: getTabLabel('Document \nPending', props.listing.documentPendingCount||0), tabKey: 'documentPending', width: !props.deviceData.isMobile ? '15' : '50'})
	}
	if(props.listing.auditPendingCount && props.listing.auditPendingCount != "0" && !viaOmni || props.tabKey == 'auditPending'){
		pendingTabs.tabs.push({value: getTabLabel('Audit \nPending', props.listing.auditPendingCount, '1'), tabKey: 'auditPending', width: !props.deviceData.isMobile ? '15' : null})
	}
	if(props.listing.objectionableTotalCount && props.listing.objectionableTotalCount != "0" || props.tabKey == 'objectionable'){
		pendingTabs.tabs.push({value: getTabLabel(props.session?.viaOmni ? 'Audit Pending' : `Objectionable ${profileObject.PluralLabelWithSpace}`, props.listing.objectionableApprovalPendingCount, (props.session?.viaOmni ? '1' : '')), tabKey: 'objectionable', width: !props.deviceData.isMobile ? '15' : '50'})
	}
	if(props.isAuditor && props.listing.objectionableTotalCount && props.listing.objectionableTotalCount != "0" || props.tabKey == 'objectionable'){
		pendingAuditorTabs.tabs.push({value: getTabLabel(`Objectionable ${profileObject.PluralLabelWithSpace}`, 0), tabKey: 'objectionable', width: !props.deviceData.isMobile ? '15' : null})
	}
	useEffect(() => {
		if (reduxPendingTabs.length === 0 || (reduxPendingTabs.length !== pendingTabs.tabs.length)) {
			dispatch(setPendingTabs(pendingTabs.tabs))
		}
	}, [pendingTabs.tabs, reduxPendingTabs])
	let lastTabIndex = pendingTabs.tabs.length - 1;
	if(props.tabKey == 'brand' && (props.listing.productConflictCount?activeTab != 3:activeTab !=2) && props.listing.suggestedProductsCount && props.listing.suggestedProductsCount != "0") {
		if(props.listing.productConflictCount){
			setActiveTab(3);
		}
	}
	if(props.tabKey == 'productConflict' && activeTab != 1 && props.listing.productConflictCount && props.listing.productConflictCount != "0") {
		setActiveTab(1);
	}
	if(props.tabKey == 'objectionable' && activeTab != lastTabIndex && props.listing.objectionableTotalCount && props.listing.objectionableTotalCount != "0") {
		setActiveTab(lastTabIndex);
	}
	if(props.isAuditor && props.tabKey == 'objectionable' && activeTab != 1 && props.listing.objectionableTotalCount && props.listing.objectionableTotalCount != "0") {
		setActiveTab(1);
	}
	if(props.isAuditor && props.tabKey == 'objectionable' && activeTab != 1  && props.listing.objectionableTotalCount == '0') {
		setActiveTab(1);
	}
	if(props.tabKey == 'brochure' && activeTab != 1){
		setActiveTab(1);
	}
	let auditHeader = 'Products'
	if(props.showSearchAdd){
		auditHeader = (<div className={styles['add-audit-header-products']} > <div className={styles['add-audit-header-products-text']} >{props.session.companyName} </div><br/><div role="button" tabIndex={0} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') props.onViewDetailsClick(true); }} className={styles['add-audit-header-view']} onClick={()=>{
			props.onViewDetailsClick(true);
		}}>VIEW DETAILS</div></div>)
	}
	let isAuditMultiSelect = (props.session.source == 'webstore' || props.showSearchAdd) && auditMultiSelect;
	if(pendingTabs.tabs.length === 4){
		pendingTabs.tabs[0].width = 22;
		pendingTabs.tabs[3].width = 28;
	}
	let sideScrollTabs = false;
	if(props.deviceData.isMobile && (pendingTabs.tabs.length > 2)){
		sideScrollTabs = true;
	}

	const openHelpUrl = () => {
        window.open('https://www.jdomni.com/support/products/view-products');
    }


    const containerRef = useRef(null)
	const VendorHeaderPopOverList=[
		{
		  label: 'Bulk Add New '+(isProductOnlyProfile == 3? 'Services': 'Products'),
		  key: 'ADD_NEW_001',
		  className: 'icon-glimport' + ' ' + styles['popoverbefore']
		},
		{
		  label: 'Bulk Update '+(isProductOnlyProfile == 3? 'Services': 'Products'),
		  key: 'BULK_UPDATE_002',
		  className: 'icon-GlExport' + ' ' + styles['popoverbefore']
		}
	]
	const handleExportClick = () => {
		setExportHistoryToggle(true);
		// openInIframe('myaccount/vendor/products/export-history');
		// return;
	}
	const handlePopOverClick = (e) => {
		console.log(e)
		switch (e.key) {
			case "ADD_NEW_001":
				if(props.isMobile) {
					history.push("/bulk-upload");
				} else {
					updateBulkStatus(false)
					updateBulkUploadOpen(true);
				}
				break;
			case "BULK_UPDATE_002":
				if(!props.isMobile) {
					updateBulkStatus(false)
					updateBulkUpdateOpen(true);
				} 				
				break;
		}
    }

	const truncateText = (text, maxLength = 22) => {
		if (text.length > maxLength) {
			return text.substring(0, maxLength) + "...";
		}
    	return text;
  	};
	const redirectToOmni = () => {
		let backUrl = props.session.backUrl ||new URLSearchParams(window.location.search).get("backurl") || "";
		if (backUrl) {
			window.location.href = backUrl;
		} else {
			window.history.back();
		}
  	};
	const fromIosFooter =  (props.session.userSource == 51 || props.session.userSource == 53) && props.session.rootVc == 1;

	return (
		<>
			
			{props.isAuditor ?
					<>
						<SliderHeader
						className={`${styles['add-audit-header']} ${showAuditorPendingTabs ? styles['add-audit-bot-unset'] : ''} ${auditorObjection ? styles['pending-auditor-objection'] : ''}`}
						heading={auditHeader}
						leftIcons={leftIconArr}
						rightIcons={rightIconArr}
						variant='secondary'
						headingClass={props.showSearchAdd ? styles['header-title'] : ''}
						defaultIconWidth = {15}
						/>
						{filterOpen && (
							<MobileFilter
								filterList={filter}
								onSubmit={onFilterSubmit}
								onFilterChange={onAuditFilterChange}
								sliderLeftIcon={leftIconArr}
								sliderRightIcon={rightIconArr}
								isMultiSelect={isAuditMultiSelect}
								isFilterOpen={filterOpen}
								isClearFilter={clearFilter}
							/>
						)}
					</>
				: (<div
				className={styles['header'] + ' ' + (isScrolled ? 'scrolled' : '') + ' ' + (showCompanyDetails ? styles['company-header'] : '') + ' ' + ((showPendingTabs || props.showVendorTabs) ? styles['tabs-header'] : '')}
			>
				{
					(isContractor || isObeFromSSO || props.session.backUrl || props?.session?.viaOmni) && showCompanyDetails?
						<div className={'heading-back'+(props?.session?.viaOmni?" static-pos":"")}>
							<div
								role="button"
								aria-label="Go back"
								tabIndex={0}
								className={`${styles['icon-holder']} `}
								onClick={() => {
									if(isContractor || isObeFromSSO){
										let baseRoute = "/list-contracts"
										if(cSearchData){
											baseRoute = "/contractor-search"
										}
										history.push(`${baseRoute}${isContractorV2?'/v2':isObeFromSSO?"/obe":''}${(window.top != window.self) ? '?loadedInIframe=true' : ''}`);
									} else{
										let backUrl = props.session.backUrl || new URLSearchParams(window.location.search).get("backurl") || '';
										if(backUrl) {
											window.location.href=backUrl;
										} else {
											window.history.back();
										}

									}
								}}
							>
								<i className={props?.session?.viaOmni ? 'icon-HDRback' :'icon-hdrBackNew'} style={{ fontSize: '1rem' }} />
							</div>
						</div>
					: null
				}
				{showCompanyDetails && !props.fromSellerDashboard ? (
					<div className={`${styles['heading-holder']} ${isContractor || isObeFromSSO ? 'contractor-header' : ''}`}>
						{props?.session?.viaOmni ? <div className={`company-name font-15${props.deviceData?.isMobile ? ' omni-mob-padding' : ''}`}>{props.session.source == 'webstore' ? 'View Products' : (<>{!props.deviceData?.isMobile && (<span role="button" tabIndex={0} aria-label="Go to Catalogue" className="catalogue-link" onClick={redirectToOmni} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') redirectToOmni(); }}>Catalogue / </span>)}Manage Catalogue </>)}</div> : <>						
							<div className={`company-name ${isContractor || isObeFromSSO ? 'font-13' : 'font-15'}`}>
								{props.deviceData.isMobile ? truncateText(props.session.companyName) : (props.session.companyName) }				
							</div>
							<div className={`sub-title ${isContractor || isObeFromSSO ? 'font-10' : 'font-12'}`}>
								{`${profileObject?.SingleLabelWithSpace.toUpperCase()} CATALOGUE`}
							</div>
						</>}
					</div>
				) : (
						<>
							<div className={styles['heading-holder']}>
								{!fromIosFooter && <AnimateOnHover
									aria-label="Go back"
									role="button"
									tabIndex={0}
									onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') e.currentTarget.click(); }}
									onClick={() => {
										if (props.imagesBeingUploaded.length) {
											props.showToastMessage({
												showToastMessage: true,
												message: 'Please wait Image Upload is in Progress',
												duration: 5000
											})
										} else {
											setTimeout(() => {
												//Session
												isVendor = JSON.parse(window.localStorage.getItem('isVendor'));
												let sdBackhandle = ['','2','52'].indexOf(props.session.userSource) != -1;
												if(docIdCheck.sd =='1' && (sdBackhandle || !props.session.userSource)){			
													window.location.replace(config.dcBizDomainUrl+'/seller-dashboard?source='+props.session.userSource+'&docid='+props.session.docId)
												}
												else if(isVendor){
													window.localStorage.removeItem('isVendor');
													window.location.replace(`/myaccount/products`);
												}else if(props.session.source == 'webstore'){
													window.location.replace(`/`);
												}else if(props.isSourceJustdial && props.session.platformDC != 'edit_listing'){
													callBackForApps(props.session.docId,props.session?.appVersion,props.isJdSourceAndroid,props.isJdSourceIOS);
													backToApp();
												}else{
													if (props.session.JDBus_ep && (props.session.userSource == '2' || props.session.userSource == '22' || props.session.userSource == '7' || props.session.userSource == '77')){
														window.location.href = `${config.dcJdbizHostUrl}/jd-business?docid=${props.session.docId}&ep=${props.session.JDBus_ep}&source=${props.session.userSource}`
													}else {
														window.history.back();	
													}
												}
											}, 300);
										}
									}}
								>
									<div
										className={`${styles['icon-holder']} `}
									>
										<i className='icon-HDRback' style={{ fontSize: '1rem' }} />
									</div>
								</AnimateOnHover>}
								{(props.session.source == 'webstore' && props.deviceData.isMobile) ? <ToggleLeftMenu></ToggleLeftMenu> : null}
							</div>
							<div className='company-name font-15'>{props.session.source == 'webstore' ? 'View Products' : 'Catalogue'}</div>
						</>
					)}
					<div className={`${styles['icon-container']} ${'font-20'}`}>
						{
							!!props.session.viaOmni && !props.isMobile ?
							<AnimateOnHover
								className={styles['full-height']}
								role="button"
								aria-label="Help"
								tabIndex={0}
								onClick={openHelpUrl}
								onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') openHelpUrl(); }}
							>
								<MobileFilterRipple className={styles['icon-holder']} clickHandler={openHelpUrl}>
									<i className={'icon-HDRhelp'} />
								</MobileFilterRipple>
							</AnimateOnHover>
							:<></>	
						}
						{
							!props.isAuditor && !props.session.viaOmni ? <Notifications /> : null
						}

						{
							!!props.session.viaOmni && !props.isMobile ?
							<AnimateOnHover
								className={styles['full-height']}
								role="button"
								aria-label="Export"
								tabIndex={0}
								onClick={() => handleExportClick()}
								onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') handleExportClick(); }}
							>
								<MobileFilterRipple className={styles['icon-holder']} clickHandler={e=>handleExportClick()}>
								<i className={'icon-GlExport'} />
								</MobileFilterRipple>
							</AnimateOnHover>
							:
							<></>
						}

						{
							!!props.session.viaOmni && !props.isMobile ?
							<div className={styles['popover']} ref={containerRef}>
							{/* <AnimateOnHover className={styles['full-height']}> */}
								{/* <MobileFilterRipple className={styles['icon-holder']} clickHandler={e=>handlePopOverClick({key:"ADD_NEW_001"})}> */}
								<MorePopover
									list={VendorHeaderPopOverList}
									containerRef={containerRef}
									onOptionClick={handlePopOverClick}
									eventType="click"
								>
									<i className={'icon-glimport'} />
								</MorePopover>
								{/* </MobileFilterRipple> */}
							{/* </AnimateOnHover> */}
							</div>
							:
							<></>
						}

						{(products.length || Object.keys(filterObj).length > 0 ) ? (
							<>
								<AnimateOnHover
									aria-label="Open filters"
									role="button"
									tabIndex={0}
									onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') e.currentTarget.click(); }}
									className={styles['full-height']}
									onClick={() => {
										setTimeout(() => {
											if(props.tabKey != "brand" && props.tabKey != "approvalPending"){
												openFilter();
											}
										}, 300);
									}}
								>
									<div
										className={`${styles['icon-holder']} ${(props.tabKey == "brand" || props.tabKey == "approvalPending") ?  styles['brand-grey'] : ""}`}
									>
										<i className='icon-filterNew' style={{ fontSize: '1rem' }} />
										{Object.keys(filterObj).length > 0 && (
											<span role="status" aria-label="Filters applied" className={styles['header-red-dot']} />
										)}
									</div>
								</AnimateOnHover>
								<AnimateOnHover
									aria-label="Search"
									role="button"
									tabIndex={0}
									onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') e.currentTarget.click(); }}
									className={styles['full-height']}
									onClick={() => {
										setTimeout(() => {
											redirectToSearch();
										}, 300);
									}}
								>
									<div
										className={`${styles['icon-holder']}`}
									>
										<i className='icon-HDRsearch' style={{ fontSize: '1rem' }} />
									</div>
								</AnimateOnHover>
								{/* <Link className={styles["icon-holder"]} to={"/search"}>
          <i className={"font-16 icon-HDRsearch"}></i>
        </Link> */}
							</>
						) : null}
					</div>
				{filterOpen && (
					<MobileFilter
						filterList={filter}
						onSubmit={onFilterSubmit}
						sliderLeftIcon={leftIconArr}
						sliderRightIcon={rightIconArr}
						isMultiSelect={props.session.source == 'b2b'}
						isFilterOpen={filterOpen}
						isClearFilter={clearFilter}
					/>
				)}
				{
					props.isSearchSliderOpen && (
						<SliderWrapper
							slider={{
								slideDirection: 'right'
							}}
							onHidden={() => {
								props.toggleSearchSlider({isSearchSliderOpen: false})
							}}
						>
							<Search
								isFilter={clearFilter}
								filterStr={actionCardSliderFilter}
							/>
						</SliderWrapper>
					)
				}
				{
					isNotificationSlider && (
						<NotificationSlider
							cardClickHandler={(data) => cardClickHandler(data)}
							sliderObj={(data) => setActionCardSliderName(data)}
						/>
					)
				}
				{!props.isMobile && bulkUploadOpen && (
					<BulkUploadSlider
						onHidden={() => updateBulkUploadOpen(false)}
						updateBulkStatus={updateBulkStatus}
					/>
				)}
				{!props.isMobile && bulkUpdateOpen && (
					<BulkUploadNewSlider
						onHidden={() => updateBulkUpdateOpen(false)}
					/>
				)}
				{!props.isMobile && exportHistoryToggle && (
					<ExportHistorySlider
						onHidden={() => setExportHistoryToggle(false)}
					/>
				)}
			</div>)}

			{!hidePhotoList && !props.session.isReadOnly && !props.isAuditor && <HorizontalPhotoList />}
			{getNotificationData?.totalActive > 0 ? (<CardSlider
				pendingTabs={pendingTabs}
				activeTab={activeTab}
				setActiveTab={setActiveTab}
				onTabChange={props.onTabChange}
				sliderObj={(data)=> (setActionCardSliderName(data))}
				cardClickHandler={(data)=> cardClickHandler(data)}
			/>) : null}
			{(!props.deviceData.isMobile && props.isActionCardSliderOpen) ? 
				<ActionCardClickSlider
					sliderName={actionCardSliderName}
					onHidden={()=>{
						(setActionCardSliderName(''))
						props.toggleActionCardSlider({isActionCardSliderOpen: false}) 
						
					}}
					// actionCardSliderToggler={()=>props.toggleActionCardSlider({isActionCardSliderOpen: false})}
				/> : null
			}
			{props.showVendorTabs ?
				<>
					<div className={`${styles['pending-tabs-holder']} ${isScrolled ? 'prod-list-scrolled' : ''} ${' tabs-'+pendingTabs.tabs.length} ${showCompanyDetails && !props.fromSellerDashboard ? '' : styles['no-company-header']}`}>
						<Tabs
							data={{
								tabs: [
									{value: `All ${profileObject.PluralLabelWithSpace}`},
									{value: `Audit Pending`}
								],
								onTabChange: (i) => props.onTabChange(i+1)
							}}
							activeTab={props.activeVendorTab - 1}
							tabClass={styles['pending-tabs']}
							sliderClass={styles['slider']}
							activeClass={styles['active']}
							variant={'bordertab'}
						/>
					</div>
					<div aria-hidden="true" className={styles['fake-tabs-div']}></div>
				</> : null
			}

			{showPendingTabs && !props.isAuditor ? (
				<>
					<div className={`${styles['pending-tabs-holder']} ${pendingTabs?.tabs?.length == 1 ? 'single-tab' : ''} ${isScrolled ? 'prod-list-scrolled' : ''} ${' tabs-'+pendingTabs.tabs.length} ${showCompanyDetails && !props.fromSellerDashboard ? '' : styles['no-company-header']} ${sideScrollTabs ? 'side-scroll-tab' : ''} ${'active-tab-'+activeTab}`} ref={ref => tabRef.current = ref} >
						<Tabs
							data={pendingTabs}
							activeTab={(activeTab>pendingTabs.tabs.length-1) ? 0:activeTab}
							tabClass={ `${styles['pending-tabs']} ${ profileObject.PluralLabelWithSpace != 'Products / Services' ? styles['extra-mar-2'] : ''}`}
							sliderClass={styles['slider']}
							activeClass={styles['active']}
							variant={'bordertab'}
						/>
					</div>
					<div aria-hidden="true" className={styles['fake-tabs-div']}></div>
				</>
			) : null}
			{showAuditorPendingTabs && props.isAuditor ? (
				<>
					<div className={`${styles['pending-tabs-holder']} ${styles['pending-auditor-tabs-holder']} ${isScrolled ? 'prod-list-scrolled' : ''} ${' tabs-'+pendingTabs.tabs.length} ${showCompanyDetails && !props.fromSellerDashboard ? '' : styles['no-company-header']} ${'active-tab-'+activeTab}`}>
						<Tabs
							data={pendingAuditorTabs}
							activeTab={activeTab}
							tabClass={styles['pending-tabs']}
							sliderClass={styles['slider']}
							activeClass={styles['active']}
							variant={'bordertab'}
						/>
					</div>
					<div aria-hidden="true" className={styles['fake-tabs-div']}></div>
				</>
			) : null}
		</>
	);
};

const mapStateToProps = state => {
	return {
		listing: state.products.listing,
		session: state.session,
		deviceData: state.deviceData,
		isMobile: state.deviceData.isMobile,
		imagesBeingUploaded: state.products.imagesBeingUploaded,
		isSourceJustdial: state.session.isJdSourceAndroid || state.session.isJdSourceIOS || (state.session.userSource == '51' || state.session.userSource == '53'),
		redirectToJdExt: state.session.redirectToJdExt,
		isSearchSliderOpen: state.products.isSearchSliderOpen,
		isActionCardSliderOpen: state.products.isActionCardSliderOpen,
		isJdBusinessIOS: state.session.isJdBusinessIOS,
		isJdSourceIOS: state.session.isJdSourceIOS, 
		isJdSourceAndroid: state.session.isJdSourceAndroid,
		tabIndex : state.products.tabIndex,
		isActiveBrochure: state.products.isActiveBrochure,
		cardCounts: state.notifications.counts,
		vendorImages:  state.products.vendorImages
	};
};

export default withRipple(
	connect(mapStateToProps, {
		getListingData,
		resetSearchData,
		showToastMessage,
		setTabStatus,
		updateDeletionPending,
		toggleSearchSlider,
		toggleActionCardSlider,
		actionCardFilter,
		updateGenericDeletionPending,
		clickTrack,
		fetchPsvInfo
	})(ListingHeader)
);
